import yup from 'core/utils/validators';

const { object, string } = yup;

export const promoCodeFormSchema = () =>
  object().shape({
    promo_code: string(),
  });
